module.exports = __webpack_public_path__ + "assets/icon-total-conversions-bg.976a5700.svg";